
import React, { useContext } from 'react';
import { PageTitle, Card, EmptyState } from '../components/common';
import { AuthContext } from '../contexts/AuthContext';
import { mockMessages } from '../mockData';

const MessagesPage: React.FC = () => {
    const auth = useContext(AuthContext);
    const userMessages = mockMessages.filter(
        m => m.recipientId === auth?.currentUser?.id || m.senderId === auth?.currentUser?.id
    );

    return (
        <div>
            <PageTitle title="Messages" subtitle="Your conversations with instructors." />

            <Card className="flex h-[calc(100vh-200px)]">
                {/* Conversations List */}
                <div className="w-full md:w-1/3 border-r border-gray-200 flex flex-col">
                    <div className="p-4 border-b font-semibold text-lg">Conversations</div>
                    {userMessages.length > 0 ? (
                        <ul className="overflow-y-auto flex-1">
                            {userMessages.map(message => (
                                <li key={message.id} className="p-4 border-b hover:bg-gray-50 cursor-pointer">
                                    <p className="font-bold text-sm">{message.subject}</p>
                                    <p className="text-sm text-gray-600 truncate">{message.content}</p>
                                </li>
                            ))}
                        </ul>
                    ) : (
                         <div className="flex-1 flex items-center justify-center p-4">
                            <p className="text-sm text-gray-500">No conversations yet.</p>
                        </div>
                    )}
                </div>
                {/* Message View */}
                <div className="hidden md:flex w-2/3 flex-col">
                    {userMessages.length > 0 ? (
                        <>
                            <div className="p-4 border-b">
                                <h2 className="text-lg font-bold">{userMessages[0].subject}</h2>
                            </div>
                            <div className="flex-1 p-6 overflow-y-auto text-gray-700">
                                <p>{userMessages[0].content}</p>
                            </div>
                        </>
                    ) : (
                        <div className="flex-1 flex items-center justify-center">
                           <EmptyState title="Select a conversation" message="Choose a conversation from the list to read messages." />
                        </div>
                    )}
                </div>
            </Card>
        </div>
    );
};

export default MessagesPage;